type Target = "Unauthorized" | "AuthorizedDeposit" | "AuthorizedNotDeposit";

type Status = "Active" | "Deactive";

export type BannerTextType = {
  button: string;
  desc: string;
  title: string;
};

export type TranslateType = {
  content: string;
  language: string;
};

export type BannerType = {
  id: number;
  name: string;
  status: Status; // статус баннера
  targeting: Target; // доступности баннера у разных групп пользователей
  weight: number; // порядковый номер банера при отображении
  fileMobUrl: string;
  fileWebUrl: string;
  redirectUrl: string;
  text: BannerTextType;
};

export type NewBannerType = {
  id: number;
  name: string;
  type: string;
  weight: number;
  turningSpeed: number;
  buttonLinkDesktop: string;
  buttonLinkMob: string;
  imgDesktop: string;
  imgMob: string;
  startDate: string;
  endDate: string;
  geo: string[];
  translate: TransaltionsBannerType[];
  translations: TransaltionsBannerType[];
};

export type TransaltionsBannerType = {
  language: string;
  titleMob: string;
  buttonName: string;
  titleDesktop: string;
  descriptionMob: string;
  descriptionDesktop: string;
};

export type CarouselSlideTypeResponseType = NewBannerType[];

// export type CarouselSlideTypeResponseType = {
//     statusCode: number;
//     banners: BannerType[];
// };

export enum ALIAS_GAME {
  AVIATOR = "aviator-spribe-3193817929df4f8481eb141698d331f0-1",
  CRAZY_TIME = "crazy-time-evolution-CrazyTime0000001-6",
  ASTRONAUT = "astronaut-100hp-gaming-0196c48a-df88-784f-adb1-8c5569b3d104-5",
  CHICKEN_ROAD = "chicken-road-2-inout-chicken-road-two-4",
}
